import React, { Component } from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Grid, Row, Col} from "react-bootstrap";

import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import { UserCard } from "../../components/UserCard/UserCard.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import avatar from "../../assets/img/wrapify-logo.png";
import {updateProfile} from "../../actions/authActions";

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.state = {
            id: this.props.auth.installer ? this.props.auth.installer.id : "",
            name: this.props.auth.installer.name,
            address1: this.props.auth.installer.address1,
            city: this.props.auth.installer.city,
            state: this.props.auth.installer.state,
            postalcode: this.props.auth.installer.postalcode,
            phone: this.props.auth.installer.phone,
            firstname: this.props.auth.installer.firstname,
            lastname: this.props.auth.installer.lastname,
            email: this.props.auth.installer.email,
            dropofftime: this.props.auth.installer.dropofftime,
            pickuptime: this.props.auth.installer.pickuptime,
            website: this.props.auth.installer.website
        }
    }

    componentDidMount() {

    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleUpdate() {
        console.log(this.state);
        this.setState({session: localStorage.sessionToken});
        this.props.updateProfile(this.state);
    }

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={8}>
                            <Card
                                title="Edit Profile"
                                content={
                                    <form>
                                        <FormInputs
                                            ncols={["col-md-12"]}
                                            proprieties={[
                                                {
                                                    label: "Company",
                                                    id: "name",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Company",
                                                    defaultValue: this.props.auth.installer.name,
                                                    disabled: false,
                                                    onChange: this.handleChange,
                                                }
                                            ]}
                                        />

                                        <FormInputs
                                            ncols={["col-md-8", "col-md-4"]}
                                            proprieties={[
                                                {
                                                    label: "Address",
                                                    id: "address1",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Home Address",
                                                    defaultValue: this.props.auth.installer.address1,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Metro",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Metro",
                                                    disabled: true,
                                                    defaultValue: this.props.auth.installer.metro_area_id
                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols={["col-md-5", "col-md-2", "col-md-5"]}
                                            proprieties={[
                                                {
                                                    label: "City",
                                                    id: "city",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "City",
                                                    defaultValue: this.props.auth.installer.city,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "State",
                                                    id: "state",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "State",
                                                    defaultValue: this.props.auth.installer.state,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Postal Code",
                                                    id: "postalcode",
                                                    type: "number",
                                                    bsClass: "form-control",
                                                    placeholder: this.props.auth.installer.postalcode,
                                                    defaultValue: this.props.auth.installer.postalcode,
                                                    onChange: this.handleChange,

                                                }
                                            ]}
                                        />

                                        <FormInputs
                                            ncols={["col-md-3", "col-md-3", "col-md-6"]}
                                            proprieties={[
                                                {
                                                    label: "Pickup",
                                                    id: "pickuptime",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Pickup",
                                                    defaultValue: this.props.auth.installer.pickuptime,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Drop off",
                                                    id: "dropofftime",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Drop off",
                                                    defaultValue: this.props.auth.installer.dropofftime,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Website",
                                                    id: "website",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Website",
                                                    defaultValue: this.props.auth.installer.website,
                                                    onChange: this.handleChange,

                                                }
                                            ]}
                                        />
                                        <div className="clearfix" />
                                    </form>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <UserCard
                                bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                                avatar={avatar}
                                name= {this.props.auth.installer.name}
                                userName=""
                                description={
                                    <span>
                  </span>
                                }
                                socials={
                                    <div>
                                        <Button simple>
                                            <i className="fa fa-facebook-square" />
                                        </Button>
                                        <Button simple>
                                            <i className="fa fa-twitter" />
                                        </Button>
                                        <Button simple>
                                            <i className="fa fa-google-plus-square" />
                                        </Button>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <Card
                                title="Primary Contact"
                                content={
                                    <form>
                                        <FormInputs
                                            ncols={["col-md-6", "col-md-6"]}
                                            proprieties={[
                                                {
                                                    label: "First Name*",
                                                    id: "firstname",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "First Name",
                                                    defaultValue: this.props.auth.installer.firstname,
                                                    disabled: false,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Last Name*",
                                                    id: "lastname",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Last Name",
                                                    defaultValue: this.props.auth.installer.lastname,
                                                    onChange: this.handleChange,

                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols={["col-md-6", "col-md-6"]}
                                            proprieties={[
                                                {
                                                    label: "Email*",
                                                    id: "email",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "First Name",
                                                    defaultValue: this.props.auth.installer.email,
                                                    disabled: false,
                                                    onChange: this.handleChange,

                                                },
                                                {
                                                    label: "Phone*",
                                                    id: "phone",
                                                    type: "text",
                                                    bsClass: "form-control",
                                                    placeholder: "Last Name",
                                                    defaultValue: this.props.auth.installer.phone,
                                                    onChange: this.handleChange,

                                                }
                                            ]}
                                        />
                                    </form>}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <Button onClick={this.handleUpdate} bsStyle="info" pullRight fill type="submit">
                                Update Profile
                            </Button>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

UserProfile.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    updateProfile: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps, {updateProfile})(UserProfile);



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx